import React, { useState, useEffect } from "react";
import MaskedInput from "react-input-mask";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import { toast } from "react-toastify";

import iconfilter from "~/assets/images/ic_filter_white.svg";
import {
  CloseIcon,
  ModalContent,
  Filters,
  Period,
  ButtonDays,
  ButtonFilter,
  Datefield,
} from "./styles";

export default function Filter(props) {
  const [filterBeginDate, setFilterBeginDate] = useState("");
  const [filterEndDate, setFilterEndDate] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [status, setStatus] = useState("TODOS");

  useEffect(() => {
    verifyFilter();
  }, []);

  function verifyFilter() {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let beginDate = params.get("begin-date");
    let endDate = params.get("end-date");
    let status = params.get("status");
    let invoiceNumber = params.get("invoice-number");

    if (beginDate && endDate) {
      if (moment(endDate).format("DD/MM/YYYY") === "Invalid date") {
        const formatedDate = endDate.split("-");
        setFilterEndDate(
          `${formatedDate[2]}-${formatedDate[1]}-${formatedDate[0]}`
        );
        setFilterBeginDate(moment(beginDate).format("DD/MM/YYYY"));
      } else if (moment(beginDate).format("DD/MM/YYYY") === "Invalid date") {
        const formatedDate = beginDate.split("-");
        setFilterBeginDate(
          `${formatedDate[2]}-${formatedDate[1]}-${formatedDate[0]}`
        );
        setFilterEndDate(moment(endDate).format("DD/MM/YYYY"));
      } else {
        setFilterBeginDate(moment(beginDate).format("DD/MM/YYYY"));
        setFilterEndDate(moment(endDate).format("DD/MM/YYYY"));
      }
    }

    if (status) {
      setStatus(status);
    }

    if (invoiceNumber) {
      setInvoiceNumber(invoiceNumber);
    }
  }

  function handlePeriod(period) {
    let beginDate = new Date();
    let endDate = new Date();

    beginDate.setDate(beginDate.getDate() - period);

    setFilterBeginDate(moment(beginDate).format("DD/MM/YYYY"));
    setFilterEndDate(moment(endDate).format("DD/MM/YYYY"));
  }

  function handleSubmit() {
    let beginDate = filterBeginDate;
    let endDate = filterEndDate;

    if (beginDate) {
      if (beginDate.length === 10) {
        const beginDay = beginDate.substring(0, 2);
        const beginMonth = beginDate.substring(3, 5);
        const beginYear = beginDate.substring(6, 10);
        beginDate = beginYear + "-" + beginMonth + "-" + beginDay;
      } else if (beginDate.length >= 11) {
        toast.error("Informe uma data inicial válida");
      }
    }

    if (endDate) {
      if (endDate.length === 10) {
        const endDay = endDate.substring(0, 2);
        const endMonth = endDate.substring(3, 5);
        const endYear = endDate.substring(6, 10);
        endDate = endYear + "-" + endMonth + "-" + endDay;
      } else if (endDate.length >= 11) {
        toast.error("Informe uma data final válida");
      }
    }

    if (beginDate && !endDate) toast.error("Data final é obrigatória!");
    if (!beginDate && endDate) toast.error("Data inicial é obrigatória!");

    // Verifica se tem só data
    if (beginDate && endDate && invoiceNumber === "")
      window.location = `/boletos?begin-date=${beginDate}&end-date=${endDate}`;

    // Verifica se tem nº da nota e data
    if (invoiceNumber && beginDate && endDate) {
      window.location = `/boletos?begin-date=${beginDate}&end-date=${endDate}&invoice-number=${invoiceNumber}&status=${status}`;
    }

    // Verifica se só tem nº da nota
    if (!beginDate && !endDate && invoiceNumber !== "") {
      window.location = `/boletos?invoice-number=${invoiceNumber}&status=${status}`;
    }

    // Verifica se tem só data
    if (beginDate && endDate !== "" && !invoiceNumber) {
      window.location = `/boletos?begin-date=${beginDate}&end-date=${endDate}&status=${status}`;
    }

    // Verifica se só tem status
    if (!beginDate && !endDate && !invoiceNumber) {
      window.location = `/boletos?status=${status}`;
    }
  }

  return (
    <Modal.Body style={{ padding: ".5rem", borderRadius: 15 }}>
      <ModalContent>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Filters
            style={{
              color: "#000FFF",
              fontSize: 18,
              fontWeight: "bold",
            }}
          >
            Filtros
          </Filters>
          <CloseIcon
            style={{ cursor: "pointer" }}
            onClick={() => props.close()}
            className="mdi mdi-close"
          />
        </div>

        <div style={{ padding: 10 }}>
          <Period>Período:</Period>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "row",
            }}
          >
            <ButtonDays onClick={() => handlePeriod(15)}>
              Últimos 15 dias
            </ButtonDays>
            <ButtonDays onClick={() => handlePeriod(30)}>
              Últimos 30 dias
            </ButtonDays>
          </div>
          <div
            style={{
              marginTop: 16,
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "row",
            }}
          >
            <ButtonDays onClick={() => handlePeriod(0)}>Diário</ButtonDays>
            <ButtonDays onClick={() => handlePeriod(7)}>Semanal</ButtonDays>
          </div>
          <hr />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div>
              <Period>Data Inicial:</Period>
              <Datefield
                as={MaskedInput}
                onChange={async (event) =>
                  setFilterBeginDate(event.target.value)
                }
                value={filterBeginDate}
                placeholder="--/--/----"
                mask="99/99/9999"
              >
                {(props) => {
                  const {
                    type,
                    name,
                    id,
                    placeholder,
                    value,
                    mask,
                    ...inputProps
                  } = props;
                  return (
                    <input
                      type={type}
                      name={name}
                      id={id}
                      placeholder={placeholder}
                      value={value}
                      {...inputProps}
                    />
                  );
                }}
              </Datefield>
            </div>
            <div style={{ paddingLeft: ".7rem" }}>
              <Period>Data Final:</Period>
              <Datefield
                as={MaskedInput}
                onChange={async (event) => setFilterEndDate(event.target.value)}
                value={filterEndDate}
                placeholder="--/--/----"
                mask="99/99/9999"
              >
                {(props) => {
                  const {
                    type,
                    name,
                    id,
                    placeholder,
                    value,
                    mask,
                    ...inputProps
                  } = props;
                  return (
                    <input
                      type={type}
                      name={name}
                      id={id}
                      placeholder={placeholder}
                      value={value}
                      {...inputProps}
                    />
                  );
                }}
              </Datefield>
            </div>
          </div>
          <hr />
          <div>
            <Period>Nº da nota fiscal:</Period>
            <input
              type="text"
              name="invoice-number"
              id="invoice-number"
              onChange={async (event) => setInvoiceNumber(event.target.value)}
              placeholder={"Nº da nota"}
              value={invoiceNumber}
              style={{
                width: "100%",
                fontSize: "1.1rem",
                padding: ".3rem 1rem",
                backgroundColor: "#fff",
                border: "1px solid #b0b0b0",
                borderRadius: "0.3rem",
                color: "#8C8C8C",
                boxShadow: "0px 3px 6px #00000066",
              }}
            />
          </div>
          <div className="d-flex w-100 flex-row align-items-center justify-content-between mt-4">
            <div
              className="d-flex flex-row align-items-center"
              onClick={() => setStatus("TODOS")}
            >
              <input
                id="TODOS"
                name="TODOS"
                type="radio"
                checked={status === "TODOS" ? true : false}
              />
              <span style={{ fontSize: 12 }} className="ml-2 mt-1">
                Todos
              </span>
            </div>
            <div
              className="d-flex flex-row align-items-center"
              onClick={() => setStatus("PAGO")}
            >
              <input
                id="PAGO"
                name="PAGO"
                type="radio"
                checked={status === "PAGO" ? true : false}
              />
              <span style={{ fontSize: 12 }} className="ml-2 mt-1">
                Pagos
              </span>
            </div>
            <div
              className="d-flex flex-row align-items-center"
              onClick={() => setStatus("A_VENCER")}
            >
              <input
                id="A_VENCER"
                name="A_VENCER"
                type="radio"
                checked={status === "A_VENCER" ? true : false}
              />
              <span style={{ fontSize: 12 }} className="ml-2 mt-1">
                A Vencer
              </span>
            </div>
            <div
              className="d-flex flex-row align-items-center"
              onClick={() => setStatus("VENCIDO")}
            >
              <input
                id="VENCIDO"
                name="VENCIDO"
                type="radio"
                checked={status === "VENCIDO" ? true : false}
              />
              <span style={{ fontSize: 12 }} className="ml-2 mt-1">
                Vencidos
              </span>
            </div>
          </div>
          <ButtonFilter onClick={() => handleSubmit()}>
            <img
              src={iconfilter}
              alt="Ícone de filtrar"
              style={{ margin: "0 -1.5rem 0 .8rem", fill: "#fff" }}
            />
            <span style={{ textAlign: "center", width: "100%" }}>Filtrar</span>
          </ButtonFilter>
        </div>
      </ModalContent>
    </Modal.Body>
  );
}
